(function () {
  const body = document.body;

  let isScrolled = false;
  let ticking = false;

  function updateScrolledState() {
    const shouldBeScrolled = window.scrollY > 0;

    if (shouldBeScrolled !== isScrolled) {
      isScrolled = shouldBeScrolled;
      body.classList.toggle("is-scrolled", isScrolled);
    }

    ticking = false;
  }

  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        requestAnimationFrame(updateScrolledState);
        ticking = true;
      }
    },
    { passive: true },
  );

  // Initial state on page load
  updateScrolledState();
})();
